module.exports = __webpack_public_path__ + "img/CMBCCNBSXXX.d02e360f.png";